/* WGIT Custom Scripts */

/* Save and restore gallery position on mobile */
function wgitSavePosition() {
  if (window.innerWidth >= 750) return null;
  var carousel = document.querySelector("[class*=ai-product-showcase-carousel-]");
  if (!carousel) return null;
  return {
    scrollY: window.scrollY,
    mt: carousel.style.marginTop,
    mb: carousel.style.marginBottom
  };
}

function wgitRestorePosition(saved) {
  if (!saved || window.innerWidth >= 750) return;
  var carousel = document.querySelector("[class*=ai-product-showcase-carousel-]");
  if (!carousel) return;
  if (saved.mt) carousel.style.marginTop = saved.mt;
  if (saved.mb) carousel.style.marginBottom = saved.mb;
  window.scrollTo(0, saved.scrollY);
}

/* Add to cart + open drawer */
function wgitCartAdd(id, callback) {
  var saved = wgitSavePosition();
  fetch("/cart/add.js", {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({items: [{id: id, quantity: 1}]})
  })
  .then(function(r) { return r.json() })
  .then(function() {
    if (callback) callback();
    document.dispatchEvent(new CustomEvent("cart:change"));
    document.dispatchEvent(new CustomEvent("cart:update"));
    var drawer = document.querySelector("cart-drawer-component");
    if (drawer && typeof drawer.open === "function") drawer.open();
    setTimeout(function() { wgitRestorePosition(saved) }, 100);
    setTimeout(function() { wgitRestorePosition(saved) }, 500);
    setTimeout(function() { wgitRestorePosition(saved) }, 1000);
  })
  .catch(function() {
    wgitRestorePosition(saved);
    window.location.href = "/cart";
  });
}

/* Bundle Add to Cart */
function wgitAddBundle(btn, id) {
  btn.textContent = "Adding...";
  btn.style.opacity = "0.6";
  wgitCartAdd(id, function() {
    btn.textContent = "Added!";
    btn.style.background = "#2d8a39";
    setTimeout(function() {
      btn.textContent = "Add to Cart";
      btn.style.background = "#1f6510";
      btn.style.opacity = "1";
    }, 1500);
  });
}

/* Floating bar Add to Cart */
function wgitAddFloating(btn) {
  var idEl = btn.closest(".wgit-floating-atc").querySelector("input[name=variant_id]");
  var id = idEl ? parseInt(idEl.value) : null;
  if (!id) return;
  wgitCartAdd(id);
}

/* Floating bar IntersectionObserver */
!function() {
  function init() {
    if (window.innerWidth >= 750) return;
    var bar = document.querySelector(".wgit-floating-atc");
    if (!bar) return;
    bar.classList.add("hidden");
    var atc = document.querySelector(".ai-product-showcase-buy-button,[class*=ai-product-showcase-buy] button");
    if (!atc) {
      var found = null;
      document.querySelectorAll("button").forEach(function(b) {
        var txt = b.textContent.trim().toLowerCase();
        if (txt.indexOf("add to cart") > -1 && !b.closest(".wgit-floating-atc") && !b.closest(".wgit-bundle-card") && !found) found = b;
      });
      atc = found;
    }
    if (!atc) return;
    new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) bar.classList.add("hidden");
        else bar.classList.remove("hidden");
      });
    }, {threshold: 0}).observe(atc);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
}();

/* Watch drawer close to restore gallery position */
!function() {
  function watchDrawer() {
    if (window.innerWidth >= 750) return;
    var drawer = document.querySelector("cart-drawer-component");
    if (!drawer) return;
    var dialog = drawer.querySelector("dialog");
    if (!dialog) return;
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === "open" && !dialog.open) {
          var carousel = document.querySelector("[class*=ai-product-showcase-carousel-]");
          var img = carousel ? carousel.querySelector("[class*=ai-product-showcase-slide] img") : null;
          if (carousel && img && img.complete && img.naturalHeight > 0) {
            var cB = carousel.getBoundingClientRect().bottom;
            var iB = img.getBoundingClientRect().bottom;
            var ds = cB - iB;
            if (ds > 12) carousel.style.marginBottom = "-" + (ds - 12) + "px";
            var thumbs = document.querySelector("[class*=ai-product-showcase-thumbnails-]");
            if (thumbs) thumbs.style.marginTop = "12px";
          }
        }
      });
    }).observe(dialog, {attributes: true});
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watchDrawer);
  else watchDrawer();
}();


/* Persistent gallery position fix */
!function() {
  if (window.innerWidth >= 750) return;
  var fixApplied = false;
  var savedMb = null;

  function applyFix() {
    var c = document.querySelector("[class*=ai-product-showcase-carousel-]");
    if (!c) return;
    var img = c.querySelector("[class*=ai-product-showcase-slide] img");
    if (!img || !img.complete || img.naturalHeight === 0) return;
    var cBottom = c.getBoundingClientRect().bottom;
    var imgBottom = img.getBoundingClientRect().bottom;
    var deadSpace = cBottom - imgBottom;
    if (deadSpace > 12) {
      savedMb = "-" + (deadSpace - 12) + "px";
      c.style.marginBottom = savedMb;
      fixApplied = true;
    }
  }

  function ensureFix() {
    if (!fixApplied || !savedMb) return;
    var c = document.querySelector("[class*=ai-product-showcase-carousel-]");
    if (c && c.style.marginBottom !== savedMb) {
      c.style.marginBottom = savedMb;
    }
  }

  // Apply on load
  function init() {
    var n = 0;
    var iv = setInterval(function() {
      applyFix();
      if (fixApplied || n++ > 30) clearInterval(iv);
    }, 300);

    // Re-apply after any cart event
    document.addEventListener("cart:change", function() { setTimeout(ensureFix, 200); setTimeout(ensureFix, 500); });
    document.addEventListener("cart:update", function() { setTimeout(ensureFix, 200); setTimeout(ensureFix, 500); });

    // Watch for style changes on carousel that might reset marginBottom
    var checkInterval = setInterval(function() {
      ensureFix();
    }, 1000);
    // Stop checking after 30 seconds to save battery
    setTimeout(function() { clearInterval(checkInterval); }, 30000);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
}();


/* Smooth scroll for stars click */
!function(){
  function init(){
    document.addEventListener("click",function(e){
      var star=e.target.closest(".wgit-stars,.wgit-product-stars");
      if(!star)return;
      e.preventDefault();
      var href=star.getAttribute("href");
      var target=href?document.querySelector(href):null;
      if(!target)target=document.querySelector(".jdgm-review-widget,[id*=product_reviews]");
      if(target)target.scrollIntoView({behavior:"smooth",block:"start"});
    });
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);
  else init();
}();